<template>
  <nav>
    <router-link to="/"></router-link> |
  </nav>
  <router-view />
</template>

<style>
body {
  font-family: 'Space Grotesk', sans-serif;
  background-color: #070223;
}
</style>
